var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DEBUG_STATES, spenttimeDebug as debug } from '../debug';
import { saveHitData } from '../hit';
import { isDotConfigured, waitingForDOT } from '../dot';
import { getVerifiedConfig } from '../config/config';
import { stateSwitch, createStateSwitch, removeStateSwitch } from '../stateSwitch';
import { addEventForCypress } from '../../utils/addCustomEvent';
import { EVENT } from '../../constants';
import { sendHit } from '../../modules/hit';
/**
 * Cleaning after measurement
 */
export var completeMeasurement = function () {
    addEventForCypress(EVENT.stateDone);
    removeStateSwitch();
    debug({
        message: "The public \"spenttime.startMeasurement\" method has been completed",
        state: DEBUG_STATES.DONE,
    });
};
/**
 * Sends the current collected data
 */
export var sendStatistics = function () {
    var statistics = stateSwitch.getStatistics(true);
    if (statistics.time === 0 && (stateSwitch.config.items ? statistics.items.length === 0 : true)) {
        return;
    }
    sendHit(statistics);
};
/**
 * The main method that starts all processes for measuring the spenttime by the user on the target element
 * @param element HTMLElement or element Id or selector
 * @param hitData Data to be sent to the server in hit
 * @param configuration Object with incoming configuration
 */
export var startMeasurement = function (element, hitData, configuration) {
    // if the measurement was previously started, then we finish it correctly
    if (stateSwitch) {
        debug({ message: 'Correct completion of the previous measurement of spenttime' });
        sendStatistics();
        completeMeasurement();
    }
    debug({
        message: 'The public "spenttime.startMeasurement" method was started',
        state: DEBUG_STATES.START,
    });
    debug(__assign({ message: 'Incoming parameters:' }, { element: element, hitData: hitData, configuration: configuration }));
    if (!('IntersectionObserver' in window)) {
        debug({
            message: "It is not possible to make a measurement on this device",
            state: DEBUG_STATES.DONE,
        });
        addEventForCypress(EVENT.measurementWillNotBePerformed);
        return;
    }
    saveHitData(hitData);
    var verifiedConfig = getVerifiedConfig(element, __assign({}, configuration));
    if (!verifiedConfig) {
        debug({
            message: "[CONF] Measuring the spent time is not possible. The public \"startMeasurement\" function has been completed",
            state: DEBUG_STATES.DONE,
        });
        addEventForCypress(EVENT.measurementWillNotBePerformed);
        return;
    }
    // passing the subsequent handler and its input parameters
    if (!isDotConfigured()) {
        waitingForDOT();
    }
    createStateSwitch(verifiedConfig);
};
